import React from 'react';
import { IDummyProps } from './types';
import { Paginator } from 'primereact/paginator';
import { getPaginatorTemplate } from './templates';
import * as meta from '../../meta-data.json';

export const View = (props: IDummyProps) => {
	const { onPageChange, paginatorTemplate, rootref, ...rest } = props;

	const paginatorStyle = getPaginatorTemplate(props);

	return (
		<div
			data-epo={`epo-paginator-${meta.version}`}
			{...{ part: `epo-paginator-${meta.version}` }}
			className={`epo-paginator-${meta.version}`}
		>
			<Paginator
				template={paginatorStyle}
				onPageChange={onPageChange}
				currentPageReportTemplate={'{currentPage} of {totalPages}'}
				ref={rootref}
				{...rest}
			></Paginator>
		</div>
	);
};
